<div class="banner-with-text contact-banner">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 class="hdg">Contact Us</h1>
        <h5 class="sb-hdg">About the Branford Group</h5>
      </div>
    </div>
  </div>
</div>

<div class="public-wrap contact-us-wrap-outer">
  <div class="contact-us-wrap">
    <div class="container">
      <div class="public-wrap-inner">
        <div class="row">
          <div class="col-md-6 right-wrap">
            <h1 class="support-hdg">Contact Us</h1>
            <p class="support-des">
              Contact us today at 203-488-7020 to speak directly with one of our
              auction services directors or complete the required fields below
              and we will contact you as soon as possible.
            </p>

            <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group mb-4 no-float-fields">
                    <label class="form-label">First Name*</label>
                    <mat-form-field appearance="outline">
                      <input matInput type="text" formControlName="firstName" [maxlength]="fieldMaxLength20"
                        placeholder="Enter your first name" />
                    </mat-form-field>
                    <control-messages [control]="contactUsForm.controls.firstName"></control-messages>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group mb-4 no-float-fields">
                    <label class="form-label">Last Name*</label>
                    <mat-form-field appearance="outline">
                      <input matInput type="text" formControlName="lastName" [maxlength]="fieldMaxLength20"
                        placeholder="Enter your last name" />
                    </mat-form-field>
                    <control-messages [control]="contactUsForm.controls.lastName"></control-messages>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group mb-4 no-float-fields">
                    <label class="form-label">Email*</label>
                    <mat-form-field appearance="outline">
                      <input matInput type="text" formControlName="email" [maxlength]="fieldMaxLength50"
                        placeholder="Enter email" />
                    </mat-form-field>
                    <control-messages [control]="contactUsForm.controls.email"></control-messages>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group mb-4 no-float-fields">
                    <label class="form-label">Phone Number*</label>
                    <mat-form-field appearance="outline">
                      <input matInput type="tel" formControlName="mobileNumber" placeholder="Enter phone number" />
                    </mat-form-field>
                    <control-messages [control]="contactUsForm.controls.mobileNumber"></control-messages>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group mb-4 no-float-fields">
                    <label class="form-label">Company*</label>
                    <mat-form-field appearance="outline">
                      <input matInput type="text" formControlName="companyName" [maxlength]="fieldMaxLength50"
                        placeholder="Enter company name" />
                    </mat-form-field>
                    <control-messages [control]="contactUsForm.controls.companyName"></control-messages>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group mb-4 no-float-fields">
                    <label class="form-label">Message*</label>
                    <mat-form-field appearance="outline">
                      <textarea formControlName="message" [maxlength]="fieldMaxLength500" rows="8" matInput
                        placeholder="Write here"></textarea>
                    </mat-form-field>
                    <control-messages [control]="contactUsForm.controls.message"></control-messages>
                  </div>
                </div>

                <div class="col-md-12" *ngIf="!isLoggedIn">
                  <div class="form-group mb-4">
                    <re-captcha required [formControl]="captcha" [siteKey]="captchaKey"></re-captcha>
                  </div>
                </div>

                <div class="col-md-12">
                  <button type="submit" [disabled]="captcha.invalid ||
                      contactUsForm.invalid || loading"
                    class="btn btn-colored mb-2 mb-md-0 mr-2">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Submit
                  </button>
                  <button type="button" [disabled]="loading" role="button" (click)="onCancel()"
                    class="btn btn-white-border mb-2 mb-md-0">
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div class="col-md-6 col-lg-5 offset-lg-1 left-wrap">
            <div class="contact-description">
              <p class="dtl d-none">
                The Branford Group's offices are located at 896 Main St in
                Branford, Connecticut. By automobile, we are 1 hour from
                Hartford, 1-1/2 hours from Providence, 2 hours from New York and
                2-1/2 hours from Boston. New Haven, home of the world's best
                brick oven pizza, Yale University, and a major railway station,
                is 15 minutes away.
              </p>
            </div>

            <div class="address-wrap">
              <div class="parts">
                <h3 class="name">Corporate Headquarters</h3>
                <div class="parts-with-icon">
                  <div class="icon-wrap">
                    <img src="/assets/images/building.svg" />
                  </div>
                  <div class="dtl-wrap address-link">
                    <a href="https://www.google.com/maps/place/896+Main+St,+Branford,+CT+06405,+USA/@41.2805557,-72.8151242,17z/data=!3m1!4b1!4m5!3m4!1s0x89e7d67a5e3e7853:0x2322b9820a95b21d!8m2!3d41.2805557!4d-72.8129355"
                      target="_blank">896 Main Street <br />
                      Branford, CT 06405</a>
                  </div>
                </div>
              </div>

              <div class="parts">
                <h3 class="name">Satellite Offices</h3>
                <div class="parts-with-icon">
                  <div class="icon-wrap">
                    <img src="/assets/images/building.svg" />
                  </div>
                  <div class="dtl-wrap">
                    Boston, MA <br />
                    Charleston, SC <br />
                    San Diego, CA <br />
                    Houston, TX <br />
                    Providence, RI <br />
                    San Francisco, CA
                  </div>
                </div>
              </div>

              <div class="parts">
                <h3 class="name">Customer Support</h3>
                <div class="parts-with-icon">
                  <div class="icon-wrap">
                    <img src="/assets/images/call.svg" />
                  </div>
                  <div class="dtl-wrap address-link">
                    Phone: 203-488-7020
                    <br />
                    eFax: 860-846-1169 <br />
                    Fax: 203-488-4577 <br />
                    <a href="mailto: service@thebranfordgroup.com">Email: Service@theBranfordGroup.com</a>
                    <br />
                    <a href="www.TheBranfordGroup.com " target="_blank">www.TheBranfordGroup.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="contact-query d-none">
          <div class="row">
            <div class="col-md-7 left-wrap">
              <div class="address-wrap">
                <div class="parts">
                  <h3 class="name">
                    For questions regarding upcoming or past auctions, if you
                    have equipment to sell, or for valuation services, contact:
                  </h3>
                  <div class="parts-with-icon">
                    <div class="icon-wrap">
                      <img src="/assets/images/call.svg" />
                    </div>
                    <div class="dtl-wrap">
                      Customer Service
                      <br />
                      1-203-488-7020
                      <br />
                      <a class="mailto" href="mailto:Service@theBranfordGroup.com">Service@theBranfordGroup.com</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-5 col-lg-4 offset-lg-1 right-wrap">
              <div class="address-wrap">
                <div class="parts">
                  <h3 class="name mb-3">Office Hours</h3>
                  <div class="parts-with-icon">
                    <div class="dtl-wrap">
                      Monday - 9:00 AM - 5:00 PM EDT
                      <br />
                      Tuesday - 9:00 AM - 5:00 PM EDT <br />
                      Wednesday - 9:00 AM - 5:00 PM EDT <br />
                      Thursday - 9:00 AM - 5:00 PM EDT <br />
                      Friday - 9:00 AM - 5:00 PM EDT
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
